import React, { useEffect, useState } from 'react';
import { UserActionLog } from '@go-client/components/UserRecords/UserActionLog';

import { FieldsReplacer } from '@go-client/components/UserRecords/Visualizations/utils';
import { getSailing } from '@go-client/lib/api/itinerary';
import { LogLoader } from '@go-client/components/UserRecords/LogLoader';

export const SailingTemplateLog: React.FC<UserActionLog> = ({ body, url }) => {
  const [logFields, setLogFields] = useState(body);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const urlParts = url!.split('/');

        // In most cases we have URLs with the sailingId in the position 4
        // and in other cases in the position 2, we will check and retry
        if (urlParts[2] || urlParts[4]) {
          let sailing = await getSailing(urlParts[4]).catch(_error =>
            console.error('Could not get the sailing')
          );
          if (!sailing) {
            sailing = await getSailing(urlParts[2]).catch(_error =>
              console.error('Could not get the sailing')
            );
          }

          if (sailing) {
            const sailingDay = sailing.days.find(d => d._id === body.sailingDayId);

            if (sailingDay) {
              const sailingDayFields = FieldsReplacer(sailingDay, logFields, [
                {
                  from: 'name',
                  to: 'sailingDayId',
                },
              ]);

              setLogFields({ ...logFields, ...sailingDayFields });
            }
          }
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [body]);

  return (
    <>
      <LogLoader isError={isError} isLoading={isLoading} fields={logFields} />
    </>
  );
};
